import GoBack from "../../BackButton/GoBack";
import donationMitaoBhookLight from "../../../Assetes/Images/mitao-bhook-light.png";
import donationMitaoBhookDark from "../../../Assetes/Images/mitao-bhook-dark.png";
import { Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDonationsData } from "../../../Redux/actions/menu";
import { useEffect, useState } from "react";
import { addDonationToCart } from "../../../Redux/actions/cart";
import IncrementDonation from "./IncrementDonation";
import DecrementDonation from "./DecrementDonation";
import { blockInvalidCharForNumberInput } from "../../../utils";
import { useTranslation } from "react-i18next";
import React from 'react';


export default function Donation() {

  const donationData = useSelector((state: any) => state.cart.donationData);
  const donationItems = useSelector((state: any) => state.cart.donationItems);
  const webAppTheme = useSelector((state: any) => state.menu.theme);
  const dispatch = useDispatch<any>();
  const [selectedDonation, setSelectedDonation] = useState<DonationProps[]>([]);
  const [donationInput, setDonationInput] = useState<number>(0);
  const { t } = useTranslation();

  const incDonation = (donation_id: number, amount: number) => {
    const item: any = selectedDonation.find((item: any) => item.donation_id === donation_id);
    item.quantity = item.quantity + 1;
    item.totalItemPrice = item.totalItemPrice + amount;
    setSelectedDonation((prev: any) => [...prev]);
    return;
  };

  const decDonation = (donation_id: number, amount: number) => {
    const item: any = selectedDonation.find((item: any) => item.donation_id === donation_id);
    if (item.quantity > 1) {
      item.quantity = item.quantity - 1;
      item.totalItemPrice = item.totalItemPrice - amount;
    }
    setSelectedDonation((prev: any) => [...prev]);
  };

  const donateNow = (donation_id: number, type: "button" | "Input") => {
    if(type == "button") {
      const item: any = selectedDonation.find((item: any) => item.donation_id === donation_id);
      if (item && item.totalItemPrice > 0) {
        dispatch(addDonationToCart(item))
        // Reset Price and quantity
        item.totalItemPrice = item.price;
        item.quantity = 1;
        setSelectedDonation((prev: any) => [...prev]);
      }
    }
    else {
      if (donationInput > 0) {
        const donationItem = {
          donation_id: donation_id,
          quantity: 1,
          price: donationInput,
          totalItemPrice: donationInput,
        };
        dispatch(addDonationToCart(donationItem))
        setDonationInput(0);
      }
    }
  }

  function donateNowControl(donation_id: number, quantity_controls: boolean, amount: number, inputHandler?: boolean) : boolean {
    let isDonateNow: boolean = false;
    if(inputHandler) {
      isDonateNow = donationInput === 0;
    }
    if(!quantity_controls || amount === 0) {
      const ifExist = donationItems?.find((item: any) => item.donation_id === donation_id);
      if (ifExist) {
        isDonateNow = true;
      }
    }
    return isDonateNow;
  }

  const donationShow = (selectedDonate: number, amount: number): number => {
    const item = selectedDonation.find((item: any) => item.donation_id === selectedDonate);
    if (item) {
      return item.totalItemPrice;
    }
    return amount
  }

  const handleDonationInput = (value: number) => {
    if (value <= 99999) {
      setDonationInput(value);
    }
  }

  useEffect(() => {
    dispatch(getDonationsData());
  }, [])

  useEffect(()=> {
    if(donationData?.length > 0) {
      const donationItem = donationData
        .filter((item: any) => item?.amount > 0)
        .map((item: any) => {
          return {
            donation_id: item.donation_id,
            quantity: 1,
            price: item.amount,
            totalItemPrice: item.amount,
          }
        });
      setSelectedDonation(donationItem);
    }
  }, [donationData])

  if(donationData?.length === 0) {
    return null;
  }
  return (
    <div className="your-cart mb-5">
      <div>
        <h5 className="your-text d-flex align-items-center gap-10 ">
          <GoBack />
          <span>{t("DONATION_HEADER")}</span>
        </h5>
      </div>
      <div className="donation-container">
        <img className="mitao-bookh-img" src={webAppTheme === 'light' ? donationMitaoBhookLight : donationMitaoBhookDark} alt="mitaoBookh" />
        <h3>
        {t("DONATION_TAGLINE")}
        </h3>
        {
          donationData?.length > 0 ?
            <div className="donation-handler">
            {
              donationData.map((donation: any) => {
                return (
                  donation?.amount > 0 ?
                    <div key={donation.donation_id}>
                      <div className={`d-flex align-item-center gap-10 your-items w-100 ${donation?.quantity_controls ? "justify-content-between" : "justify-content-center"}`}>
                        <DecrementDonation isShow={donation?.quantity_controls} decDonation={() => decDonation(donation.donation_id, donation?.amount)} />
                        <div>
                          <span className="price-tag">Rs.</span>{" "}
                          <span className="cont-item">
                            { donationShow(donation.donation_id, donation?.amount) }
                          </span>
                        </div>
                        <IncrementDonation isShow={donation?.quantity_controls} incDonation={() => incDonation(donation.donation_id, donation?.amount)} />
                      </div>
                      <Button
                        variant="contained"
                        className={`bg-theme w-100 mt-3 font-bold ${donateNowControl(donation.donation_id, donation?.quantity_controls, donation.amount) ? "disable-btn" : "able-btn"}`} 
                        onClick={() => donateNow(donation.donation_id, "button")}
                        disabled={donateNowControl(donation.donation_id, donation?.quantity_controls, donation.amount)}
                      >
                         {t("DONATE_NOW")}
                      </Button>
                    </div>
                    :
                    <div key={donation.donation_id}>
                      <div className="d-flex align-item-center gap-10 your-items w-100 justify-content-between">
                        <TextField
                          value={donationInput == 0 ? "" : donationInput}
                          onChange={(e) => handleDonationInput(Number(e.target.value))}
                          onKeyDown={blockInvalidCharForNumberInput}
                          type="number"
                          name="donationInput"
                          disabled={donateNowControl(donation.donation_id, donation?.quantity_controls, donation.amount) ? true : false}
                          className="field-style coupon-input disable-fields !mt-0"
                          inputProps={{ style: { height: "15px" } }}
                          label={t("ENTER_AMOUNT")}
                          variant="filled"
                          color="error"
                        />
                      </div>
                      <Button
                        variant="contained"
                        className={`bg-theme w-100 mt-3 font-bold ${donateNowControl(donation.donation_id, donation?.quantity_controls, donation.amount, true) ? "disable-btn" : "able-btn"}`} 
                        onClick={() => donateNow(donation.donation_id, "Input")}
                        disabled={donateNowControl(donation.donation_id, donation?.quantity_controls, donation.amount, true)}
                      >
                        {t("DONATE_NOW")}
                      </Button>
                    </div>
                )
              })
            }
            </div>
          :
          null
        }
      </div>
    </div>
  );
}